import logo from "../images/rt-logo.webp";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Nav.scss";
import { slide as Menu } from "react-burger-menu";

export default function Nav() {
  const navigate = useNavigate();
  const [locationNav, setLocationNav] = useState(false);

  useEffect(() => {
    if (
      window.location.pathname === "/locations" ||
      window.location.pathname === "/laundry" ||
      window.location.pathname === "/apply"
    ) {
      setLocationNav(true);
    }
  }, []);

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);

  const pageTitle = (title) => {
    document.title = `RaceTrack Pitstop | ${title}`;
  };

  return (
    <>
      <header className="global-navbar">
        <div className="navbar-container">
          {/* Left Side: Brand Logo */}
          <div className="navbar-logo" onClick={() => navigate("/")}>
            <img src={logo} alt="RaceTrack Pitstop Logo" />
          </div>

          <nav className="navbar-links">
            <a
              href={locationNav ? "/#aboutSection" : "#aboutSection"}
              onClick={(e) => {
                pageTitle("About Us");
                if (locationNav) {
                  e.preventDefault();
                  navigate("/#aboutSection");
                }
              }}
            >
              About
            </a>
            <a
              href="/locations"
              onClick={(e) => {
                e.preventDefault();
                pageTitle("Stores");
                navigate("/locations");
              }}
            >
              Stores
            </a>
            <a
              href={locationNav ? "/#deals" : "#deals"}
              onClick={(e) => {
                pageTitle("Shop");
                if (locationNav) {
                  e.preventDefault();
                  navigate("/#deals");
                }
              }}
            >
              Shop
            </a>
            <a
              href={locationNav ? "/#awards" : "#awards"}
              onClick={(e) => {
                pageTitle("Awards");
                if (locationNav) {
                  e.preventDefault();
                  navigate("/#awards");
                }
              }}
            >
              Awards
            </a>
            <a
              href="/apply"
              onClick={(e) => {
                e.preventDefault();
                pageTitle("Apply");
                navigate("/apply");
              }}
            >
              Apply
            </a>
          </nav>

          {/* Right Side: Action CTA Button */}
          <div className="navbar-actions">
            <a
              href="/app"
              className="navbar-btn-download"
            >
              Download App
            </a>
          </div>
        </div>
      </header>

      {/* Hambuger Menu Starts */}
      <Menu pageWrapId={"page-wrap"} outerContainerId={"outer-container"} right>
        <a
          id="aboutLink"
          className="menu-item"
          href={locationNav ? "/#aboutSection" : "#aboutSection"}
          onClick={(e) => {
            pageTitle("About Us");
            if (locationNav) {
              e.preventDefault();
              navigate("/#aboutSection");
            }
          }}
        >
          About
        </a>
        <a
          id="stores"
          className="menu-item"
          href="/locations"
          onClick={(e) => {
            e.preventDefault();
            pageTitle("Stores");
            navigate("/locations");
          }}
        >
          Stores
        </a>
        <a
          id="shop"
          className="menu-item"
          href={locationNav ? "/#deals" : "#deals"}
          onClick={(e) => {
            pageTitle("Shop");
            if (locationNav) {
              e.preventDefault();
              navigate("/#deals");
            }
          }}
        >
          Shop
        </a>
        <a
          href={locationNav ? "/#awards" : "#awards"}
          onClick={(e) => {
            pageTitle("Awards");
            if (locationNav) {
              e.preventDefault();
              navigate("/#awards");
            }
          }}
        >
          Awards
        </a>
        <a
          id="apply"
          className="menu-item"
          href="/apply"
          onClick={(e) => {
            e.preventDefault();
            pageTitle("Apply");
            navigate("/apply");
          }}
        >
          Apply
        </a>

        {/* Mobile Call To Action inside the drawer */}
        <a
          href="/app"
          className="bm-download-btn"
        >
          Download App
        </a>
      </Menu>
      {/* Hamburger Menu Ends */}
    </>
  );
}
